@for (filter of filters; track filter.name) {
    <cc-multi-select-dropdown
        [placeholder]="'Please Select'"
        [label]="filter.displayName"
        [error]="filter.error"
        [anchorType]="'filter'"
        [anchorAlignment]="'right'"
        [emitOnCloseOnly]="true"
        [suppressMultiSelectAll]="true"
        [options]="(filter.options | async) ?? []"
        [disabled]="!(filter.options | async)?.length"
        [searchable]="true"
        [(selected)]="filter.selectedOptions"
        (selectedChange)="onSelectedOptionsChanged($event, filter)"
    >
    </cc-multi-select-dropdown>
}
